import React from 'react';
import cipherLogo from '../assets/cipher-icon-only-transparent.png';
import { colors as theme } from '../theme';

const colors = {
  bg: theme.bg,
};

/**
 * Full-screen pulsing-logo loader — replaces the old spinning-circle loader
 * everywhere it's used: boot/auth resolution (including the cross-app
 * handoff from Cipher Nutrition) and in-page data loads like
 * ClientProgramView's and EnhancedStats' loading states, so the loading
 * feel stays consistent instead of reverting to the old spinner.
 */
const LoadingScreen = () => (
  <div style={{
    minHeight: '100dvh',
    background: colors.bg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}>
    <img
      src={cipherLogo}
      alt="Cipher"
      style={{
        width: '144px',
        height: '144px',
        animation: 'cipherLogoPulse 1.1s ease-in-out infinite',
      }}
    />
    <style>{`
      @keyframes cipherLogoPulse {
        0%, 100% { opacity: 0.85; transform: scale(1); }
        50% { opacity: 1; transform: scale(1.06); }
      }
    `}</style>
  </div>
);

/**
 * Wraps the first real screen shown after LoadingScreen (home/dashboard/
 * onboarding/paywall/pending-approval/suspended/rejected) with a one-time
 * slide-and-fade reveal. `active` should be true only for the single render
 * right after auth resolves from the boot loading state — App.jsx tracks
 * this with a ref so it never replays on later in-app navigation.
 */
export const RevealOnMount = ({ active, children }) => (
  <div style={active ? { animation: 'cipherRevealIn 420ms cubic-bezier(0.16, 1, 0.3, 1) both' } : undefined}>
    {active && (
      <style>{`
        @keyframes cipherRevealIn {
          0% { opacity: 0; transform: translateX(32px); }
          100% { opacity: 1; transform: translateX(0); }
        }
      `}</style>
    )}
    {children}
  </div>
);

export default LoadingScreen;
